/*
 * For more information about the V1 Rest API see:
 * https://www.revenuecat.com/docs/api-v1
 */

import type { GetOrCreateCustomerResponse } from '@/interfaces/revenueCat';

import axios from 'axios';

const revenueCatAPI = axios.create({
	baseURL: `${JW_CONFIG.REVENUE_CAT_API_URL}`,
});

revenueCatAPI.interceptors.request.use(
	async config => {
		config.headers = {
			Authorization: `Bearer ${JW_CONFIG.REVENUE_CAT_PUBLIC_KEY}`,
		};
		return config;
	},
	error => Promise.reject(error)
);

export const revenueCatService = {
	/** Gets the latest Customer Info for the customer with the given App User ID, or creates a new customer if it doesn't exist. */
	getSubscriber: async (userId: string) => {
		const response = await revenueCatAPI.get<GetOrCreateCustomerResponse>(`/subscribers/${userId}`);
		return response.data;
	},
};
